import api from '../axiosConfig';

const API_URL = '/api/reports';

export const fetchStoneStockAddedReport = (filters = {}) => {
  return api.get(`${API_URL}/stone-stock-added`, { params: filters });
};